import { Component, OnInit } from '@angular/core';
import { DynamicInputComponent, MenuGroup } from '../dynamic-input-model';
import { PoliciesInputComponent } from './policies-input/policies-input.component';
import { BaseEditor } from '../base-editor';
import { EditorService } from '../services/editor.service';
import { NbMenuItem, NbMenuService } from '@nebular/theme';

@Component({
  selector: 'ngx-policies-editor',
  templateUrl: './policies-editor.component.html',
  styleUrls: ['./policies-editor.component.scss']
})
export class PoliciesEditorComponent extends BaseEditor implements OnInit{

  inputComponent = new DynamicInputComponent(PoliciesInputComponent);
  title = "Editing Policies Route";
  menuTag = "editPoliciesPageRouteMenu";

  menuGroup:MenuGroup = {
    title:"Editing Policies Page Route",
    menuTag:"editPoliciesPageRouteMenu",
    menuItems: [
      {
        title:"Page Settings"
      },
      {
        title:"Sections"
      },
      {
        title:'Add Section',
        children:[
          {
            title:'Grid',
            children:[
              {
                title:'Add New Grid'
              },
              {
                title:'Edit Existing Grid'
              }
            ]
          },
          {
            title:'Banner'
          },
          {
            title:'Slider'
          },
          {
            title:'Slide Show'
          }
        ]
      },
      {
        title:'Remove Section',
      },
      {
        title:'Order Sections',
      },
    ]
  }
  menuItems:NbMenuItem[] = [
    {
      title:'Settings'
    },
    {
      title:'Sections'
    },
    {
      title:'Add Section',
    },
    {
      title:'Remove Section'
    },
    {
      title:'Order Sections'
    }
  ]
  previousMenu:NbMenuItem[] = [];
  constructor(editorService:EditorService,
    menuService:NbMenuService){
      super(editorService,menuService)
    }

    ngOnInit(): void {
      super.ngOnInit()
      /* this.menuGroups = this.editorService.createMenusFromGroup(this.menuGroup);
      this.inputComponent.data = this.menuGroups;
      this.editorService.setInputComponent(this.inputComponent);
      console.log(this.menuGroups);
      this.menuService.onItemClick().subscribe(menuBag =>{
        let selectedItem = menuBag.item;
        if(selectedItem != undefined){
          this.setMenu(selectedItem);
        }
      }) */
    }

    /* setMenu(selectedItem:NbMenuItem){
      if(selectedItem.title == "Back"){
        this.menuItems = this.previousMenu;
      }else{
        this.menuGroup.menuItems.forEach(menuItem => {
          if(menuItem.title == selectedItem.title && menuItem.children != null){
            this.previousMenu = this.menuItems;
            console.log(menuItem.title);
            let backLinkLNbMenuItem = {title:"Back",icon:"arrow-back-outline"};
            let headerItem:NbMenuItem = {title:menuItem.title,group:true}
            this.menuItems = [backLinkLNbMenuItem,headerItem].concat(menuItem.children);
          }
        })
      }
      
    } */

}
